goog.provide('yext.social.generatedcontent.routes');

goog.require('yext.storm.routerDEPRECATED');

// Routes set in src/com/yext/socialstorm/app/views/Social/UserGeneratedContent/view.html
yext.social.generatedcontent.routes = {};
goog.exportSymbol('yext.social.generatedcontent.routes', yext.social.generatedcontent.routes);

goog.scope(function() {
  var route = yext.storm.routerDEPRECATED.route;

  yext.social.generatedcontent.routes.GmbUserGeneratedContent = {
    search: route('social/usergeneratedcontent/gmb/search'),
    searchUsers: route('social/usergeneratedcontent/gmb/searchUsers'),
    filterFetcher: route('social/usergeneratedcontent/gmb/filterFetcher'),
    handleMediaRemoved: route('social/usergeneratedcontent/gmb/handleMediaRemoved'),
  };
});
